
(function () {

    $.fn.throbber = function(options) {
        var throbber = createThrobber.call(this, options);
        var result = {
            $el: throbber,
            show: function() {
                throbber.show();
            },
            hide: function() {
                throbber.hide();
            },
            remove: function() {
                throbber.remove();
            },
            start: function() {
                var throb = result.$el.find(".throbber");
                if (throb.find("div").length != 3) {
                    throb.empty();
                    addBounce.call(throb, options);
                }
                result.started = true;
                result.show();
                return result;
            },
            stop: function() {
                result.started = false;
                result.hide();
                result.$el.find(".throbber").empty();
                return result;
            },
            toggle: function(on){
                if (on === undefined) {
                    if (result.started) {
                        return result.stop();
                    }
                    else {
                        return result.start();
                    }
                }
                else if (on) {
                    return result.start();
                }
                else {
                    return result.stop();
                }
            }
        };
        return result;
    }

    function createThrobber(options) {
        var child = $(this).children(".throbber-container");
        if (child.length > 0) {
            return child.first();
        }

        var container = $("<div>");
        container.addClass("throbber-container");

        if (options && options.vertical) {
            container.addClass("vertical");
        }

        if (!options || options.mask != false) {
            var mask = $("<div>");
            mask.addClass("mask");
            container.append(mask);
        }

        var throbber = $("<div>");
        throbber.addClass("throbber");

        if (options && options.size) {
            throbber.css({ 
                width: options.size + 4 /* Left/Right margin */ + 2 /* buffer */,
                height: (options.size + 4 /* Left/Right margin */) * 3 - 2 /* buffer */
            });
        }

        if (options && options.align) {
            switch (options.align) {
                case "top": throbber.css({top: 0, bottom: "auto"});
                    break;
                case "bottom": throbber.css({bottom: 0, top: "auto"});
                    break;
                case "left": throbber.css({left: 0, right: "auto"});
                    break;
                case "right": throbber.css({right: 0, left: "auto"});
                    break;
            }
        }

        if (options && options.show == true) {
            addBounce.call(throbber, options);
        }

        container.append(throbber);

        if (!options || options.show != true) {
            container.hide();
        }

        $(this).append(container);

        return container;
    }

    function addBounce(options) {
        var bounce1 = $("<div>)");
        bounce1.addClass("bounce1");

        var bounce2 = $("<div>)");
        bounce2.addClass("bounce2");

        var bounce3 = $("<div>)");
        bounce3.addClass("bounce3");

        if (options && options.size) {
            bounce1.css({ "width": options.size, "height": options.size });
            bounce2.css({ "width": options.size, "height": options.size });
            bounce3.css({ "width": options.size, "height": options.size });
        }

        if (options && options.color) {
            bounce1.css({ "background-color": options.color });
            bounce2.css({ "background-color": options.color });
            bounce3.css({ "background-color": options.color });
        }

        $(this).append(bounce1);
        $(this).append(bounce2);
        $(this).append(bounce3);
    }
})();